module.exports = __webpack_public_path__ + "img/action-success.d281b168.svg";